export const GET_LOAD_BY_ID = 'GET_LOAD_BY_ID';
export const GET_LOAD_STOPS = 'GET_LOAD_STOPS';
export const GET_MAP_UPDATES = 'GET_MAP_UPDATES';
export const GET_SHIP_CON_DISPATCHES = 'GET_SHIP_CON_DISPATCHES';
